import { syncDirtyBudgets } from "containers/Budget/_actions";
import appActionType from "containers/App/_actions";
import ReactGA from "react-ga4";

const actionType = {
    SNOWFALL_SAVE: "SNOWFALL_SAVE",
    SNOWFALL_DELETE: "SNOWFALL_DELETE",
};
export default actionType;

export const saveSnowfall = (farmId, budgetId, snowfall) => (dispatch) => {
    ReactGA.event({
        category: "Climate",
        action: "Save",
    });
    dispatch({ type: actionType.SNOWFALL_SAVE, payload: { farmId, budgetId, snowfall } });
    dispatch(syncDirtyBudgets(budgetId));
};

export const deleteSnowfall = (farmId, budgetId, snowfallId) => (dispatch) => {
    ReactGA.event({
        category: "Climate",
        action: "Delete",
    });
    dispatch({ type: actionType.SNOWFALL_DELETE, payload: { farmId, budgetId, snowfallId } });
    dispatch({ type: appActionType.APP_CLOSE_MODAL });
    dispatch(syncDirtyBudgets(budgetId));
};
